// Core
import React from 'react';
import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

// Pages that only make sense for a signed-in user (the API ignores them otherwise).
// The store is seeded from localStorage before the first render, so there is no flash of redirect.
const RequireAuth = ({ children }) => {
  const { userDetails } = useSelector((store) => store.commonData);
  return userDetails ? children : <Navigate to='/' replace />;
};

export default RequireAuth;

RequireAuth.propTypes = {
  children: PropTypes.node
};
